export const pgaTypes = {
  LACEY: 'LACEY',
  TSCA: 'TSCA',
  DISCLAIM_PGA: 'DISCLAIM_PGA',
  NHTSA: 'NHTSA',
  FDA_FOO: 'FDA_FOO',
  FDA_DEV: 'FDA_DEV',
  FDA_RAD: 'FDA_RAD',
  DEA_DEA: 'DEA_DEA',
  DEA_MAC: 'DEA_MAC',
  ATF_ATF: 'ATF_ATF',
  FDA_DRU: 'FDA_DRU',
  EPA_VNE: 'EPA_VNE',
  EPA_ODS: 'EPA_ODS',
  APH_APQ: 'APH_APQ',
  FDA_COS: 'FDA_COS',
  FWS: 'FWS',
  EPA_PS1: 'EPA_PS1',
  EPA_PS2: 'EPA_PS2',
  EPA_PS3: 'EPA_PS3',
  EPA_HFC: 'EPA_HFC',
  APH_AVS: 'APH_AVS',
  NMFS_SIM: 'NMFS_SIM',
  AMS_OR: 'AMS_OR',
  AMS_OR2: 'AMS_OR2',
  AMS_MO: 'AMS_MO',
  AMS_EG:'AMS_EG',
  APH_AAC:'APH_AAC',
  APH_ABS:'APH_ABS',
  FDA_BIO:'FDA_BIO',
  FDA_TOB:'FDA_TOB',
  FDA_VME:'FDA_VME',
  FSI_FSI:'FSI_FSI',
  NHT_MVS:'NHT_MVS',
  NHT_OEI:'NHT_OEI',
  FDA_TOB:'FDA_TOB',
  NHT_OFF:'NHT_OFF',
  NHT_REI:'NHT_REI',
  NHT_TPE:'NHT_TPE',
  NMF_370:'NMF_370',
  OMC_OMC:'OMC_OMC',
  TTB_BER:'TTB_BER',
  TTB_DSP:'TTB_DSP',
  TTB_TOB:'TTB_TOB',
  TTB_WIN:'TTB_WIN',
  NMFS_HMS: 'NMFS_HMS',
  NMFS_AMR: 'NMFS_AMR',
  CPSC: 'CPSC'
};

export const pgaHumanNames = {
  AMS_MO:"Marketing Order",
  AMS_EG:"Imported Egg",
  AMS_PN:"Imported Peanut",
  AMS_OR:"Organics - Paper NOP Import",
  AMS_OR2:"Organics - Electronic NOP Import",
  APH_AAC:"Animal Care",
  APH_APQ:"Plant Protection & Quarantine",
  APH_APL:"Lacey Act",
  LACEY:"Lacey Act",
  APH_AVS:"Veterinary Services",
  NMFS_SIM: "National Maritime Fisheries Service - Seafood Importing Service",
  APH_ABS:"Biotechnology",
  ATF_ATF:"ATF",
  DEA_DEA:"DEA",
  DEA_MAC:"DEA (DE3)",
  DTC_DTC:"Defense Trade Control",
  EPA_ODS:"Ozone Depleting Substances",
  EPA_VNE:"Vehicles & Engines",
  EPA_PS1:"Registered Pesticides",
  EPA_PS2:"Pesticides - Devices",
  EPA_PS3:"Pesticides - Other",
  EPA_HFC:"Hydrofluorocarbons",
  EPA_TS1:"TSCA",
  EPA_TS2:"TSCA - Blanket",
  FDA_BIO:"Biologics",
  FDA_COS:"Cosmetics",
  FDA_TOB:"FDA - Tobacco",
  FDA_DEV:"Medical Devices",
  FDA_DRU:"Drugs",
  FDA_FOO:"Foods",
  FDA_RAD:"Radiation Emitting Products",
  FDA_TOB:"Tobacco",
  FDA_VME:"Veterinary Drugs",
  FDA_FDA:"Disclaim",
  FSI_FSI:"Food Safety Inspection",
  FWS_FWS:"Fish & Wildlife",
  NHTSA:"Motor Vehicles",
  NHT_MVS:"Motor Vehicles",
  NHT_REI:"Regulated Equipment",
  NHT_TPE:"Replacement Equipment",
  NHT_OEI:"Other Equipment",
  NHT_OFF:"Off Road",
  NMF_370:"TTVP/370 Tuna Tracking",
  TSCA:"Toxic Substances Control Act",
  NMFS_HMS:"Highly Migratory Species",
  NMFS_AMR:"Antarctic Marine Resources",
  CPSC:"CPSC (Consumer Product Safety)",
  NMF_SIM:"Seafood Import Monitoring",
  OMC_OMC:"Office of Marine Conservation",
  TTB_BER:"Beer",
  TTB_DSP:"Distilled Spirits",
  TTB_TOB:"Tobacco",
  TTB_WIN:"Wine",
}

export const pgaFlagTypeList = {
  LACEY: 'LaceyActFlag',
  TSCA: 'TSCAFlag',
  DISCLAIM_PGA: 'disclaimPgaFlag',
  NHTSA: 'nhtsaFlag',
  FDA_FOO: 'fdaFooFlag',
  FDA_DEV: 'fdaDevFlag',
  FDA_RAD: 'fdaRadFlag',
  DEA_DEA: 'deaDeaFlag',
  DEA_MAC: 'deaMacFlag',
  FDA_DRU: 'fdaDruFlag',
  EPA_VNE: 'epaVneFlag',
  EPA_ODS: 'epaOdsFlag',
  APH_APQ: 'aphApqFlag',
  FDA_COS: 'fdaCosFlag',
  FDA_TOB: 'fdaTobFlag',
  FWS: 'fwsFwsFlag',
  EPA_PS1: 'epaPs1Flag',
  EPA_PS2: 'epaPs2Flag',
  EPA_PS3: 'epaPs3Flag',
  EPA_HFC: 'epaHfcFlag',
  APH_AVS: 'aphAvsFlag',
  AMS_OR: 'amsOrFlag',
  AMS_OR2: 'amsOr2Flag',
  AMS_MO:  'amsMoFlag',
  NMFS_SIM: 'nmfsSimFlag',
  ATF_ATF: 'atfAtfFlag',
  AMS_EG:'amsEgFlag',
  APH_AAC:'aphAacFlag',
  APH_ABS:'aphAbsFlag',
  FDA_BIO:'fdaBioFlag',
  FDA_TOB:'fdaTobFlag',
  FDA_VME:'fdaVmeFlag',
  FSI_FSI:'fsiFsiFlag',
  NHT_MVS:'nhtMvsFlag',
  NHT_REI:'nhtsaFlag',
  NHT_OEI:'nhtOeiFlag',
  NHT_OFF:'nhtOffFlag',
  NHT_TPE:'nhtTpeFlag',
  NMF_370:'nmf370Flag',
  OMC_OMC:'omcOmcFlag',
  TTB_BER:'ttbBerFlag',
  TTB_DSP:'ttbDspFlag',
  TTB_TOB:'ttbTobFlag',
  TTB_WIN:'ttbWinFlag',
  NMFS_HMS: 'nmfshmsFlag',
  NMFS_AMR: 'nmfsamrFlag',
  CPSC: 'cpscCpsFlag'
};

// Canadian province codes that should be normalized to "CA" for PGAs
export const CANADIAN_PROVINCE_CODES = ["XA","XB","XC","XM","XN","XO","XP","XQ","XS","XT","XV","XW","XY"];

// AMS_OR2 not available before this date (March 19, 2024)
export const AMS_OR2_MIN_DATE_EPOCH = 1710806400000;

// Programs that support disclaim feature (currently only FDA and APH)
export const PROGRAMS_WITH_DISCLAIM_SUPPORT = ["FDA","APH"];